import React from 'react';
import Navigation from './Navigation';
import HeroSection from './HeroSection';
import CompanyIntro from './CompanyIntro';
import ProjectsSection from './ProjectsSection';
import MapSection from './MapSection';
import PricingSection from './PricingSection';
import BrochureSection from './BrochureSection';
import Footer from './Footer';
import { siteConfig } from '../config/siteConfig';
import './HomeWeb.css';

const HomeWeb = ({ config = siteConfig }) => {
  return (
    <div className="home-web">
      <Navigation config={config.navigation} />
      <HeroSection config={config.hero} />
      <CompanyIntro config={config.companyIntro} />
      <ProjectsSection config={config.projects} />
      <MapSection config={config.map} />
      <PricingSection config={config.pricing} />
      <BrochureSection config={config.brochure} />
      <Footer config={config.footer} />
    </div>
  );
};

export default HomeWeb;
